import React from 'react';
import { Modal } from 'react-bootstrap';
import l10n from 'localization/LocalizationData';

interface ImageShowerProps {
	url: string;
	alt: string;
}

export const ImageShower = (props: ImageShowerProps) => {
	const [showModal, setShowModal] = React.useState(false);


	return (
		<React.Fragment>
			<button className='imageshower-button' onClick={() => setShowModal(true)}>{l10n.button_openPicture}</button>
			<Modal className='imageshower' aria-label='Esimerkki kuva' centered={true} show={showModal} onHide={() => setShowModal(false)}>
				<Modal.Header closeButton/>
				<img alt={`kuvaesimerkki: ${props.alt}`} src={props.url}/>
			</Modal>
		</React.Fragment>
	);
}